import { useSyncExternalStore } from 'react';

export function subscribe<T>(initVal?: T) {
    let state: T = initVal!;
    const dep = new Set<() => void>();
    const getState = () => state;
    const setState = (nextState: any) => {
        const next =
            typeof nextState === 'function' ? nextState(state) : nextState;
        if (!Object.is(state, next)) {
            state = next;
            dep.forEach((render) => render());
        }
    };
    const useScribe = Object.assign(
        () => {
            return useSyncExternalStore(
                (render) => {
                    dep.add(render);
                    return () => dep.delete(render);
                },
                () => state
            );
        },
        { getState, setState }
    );
    return useScribe;
}
